import { Component, TemplateRef, ViewChild } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  templateUrl: './shared-error-login.component.html',
  styleUrls: ['./shared-error-login.component.less']
})
export class SharedErrorLoginComponent {

  @ViewChild('errLogin')
  public errLogin: TemplateRef<any>;

  constructor(
    public deviceService: DeviceDetectorService,
  ) { }

}
